const Section = ({ framed_footer }) => {
    return <>
    <div className="cartons_container">
    {framed_footer?.map(item => (
              
              <p className={item.framed_footer_box_text && item.framed_footer_box_right_justified ? "show p-2 m-2 section1" : "hide"}>
             <span className="float-left textColor-Type8 font-small">{item.framed_footer_box_text}</span> 
             <span className="float-right textColor-Type1 font-small">{item.framed_footer_box_right_justified}</span> 
              </p>
              ))}
    </div>

            </>

    
    
}

export default Section;